
// -------------- AREA Page --------------
import {USER_SET_ALL} from "./userActions";

export const AREA_SET_STATE = 'AREA_SET_STATE';
export const AREA_SET_CITY  = 'AREA_SET_CITY';
export const AREA_GET_ALL   = 'AREA_GET_ALL';


// -------------- State Page --------------
export const STATE_SET_ITEM = 'STATE_SET_ITEM';
export const STATE_ADD_ITEM = 'STATE_ADD_ITEM';
export const STATE_SET_ALL  = 'STATE_SET_ALL';
export const CITY_GET_ITEM  = 'CITY_GET_ITEM';

// -------------- city Page --------------
export const CITY_SET_ITEM = 'CITY_SET_ITEM';
export const CITY_ADD_ITEM = 'CITY_ADD_ITEM';
export const CITY_GET_ALL  = 'CITY_GET_ALL';



// --------- AREA Page ---------
export function areaGetItem(areaList) {
    return { type: AREA_GET_ALL, data: areaList }
}
export function cityList(cityList) {
    return { type: AREA_SET_CITY, data: cityList }
}

// --------- State Page ---------
export function stateSetItem(stateList) {
    return { type: STATE_SET_ITEM, data: stateList }
}
export function stateAddItem(stateAddItem) {
    return { type: STATE_ADD_ITEM, data: stateAddItem }
}
export function stateSetList(allState) {
    return { type: STATE_SET_ALL, data: allState }
}

// --------- city Page ---------
export function citySetItem(cityList) {
    return { type: CITY_SET_ITEM, data: cityList }
}
export function cityGetItem(getItem) {
    return { type: CITY_GET_ITEM, data: getItem }
}
export function cityAddItem(cityAddItem) {
    return { type: CITY_ADD_ITEM, data: cityAddItem }
}
export function cityGetList(allCity) {
    return { type: CITY_GET_ALL, data: allCity }
}
